/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Result_Action_Email_SendInputs */



/**
* | output |
* | --- |
* | "Send an email from Outlook" |
*
* @param {Agent_Result_Action_Email_SendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_result_action_email_send = /** @type {((inputs?: Agent_Result_Action_Email_SendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Result_Action_Email_SendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail über Outlook senden")
	return /** @type {LocalizedString} */ ("Send an email from Outlook")
});